<template lang="pug">
  TransitionExpand
    div(v-show='isActive', key="div")
      slot
</template>

<script>
export default {
  name: 'Tab',
  props: {
    name: { required: true },
    selected: { default: false }
  },
  data () {
    return {
      isActive: false
    }
  },
  mounted () {
    this.isActive = this.selected
  }
}
</script>

<style scoped>

</style>
